export default __webpack_public_path__ + "static/media/pvilla2-1.43ef51fe.webp";